export default __webpack_public_path__ + "static/media/recharge_dam.83eda3c2.png";